<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="客户类型" prop="userType">
              <el-select v-model="form.userType" multiple>
                <el-option label="储运客户" value="2"></el-option>
                <el-option label="云销客户" value="3"></el-option>
                <el-option label="供应商" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录账号" prop="loginId">
              <el-input v-model="form.loginId" placeholder="请输入登录账号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <span>默认密码是手机号后六位</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="form.mobile" maxlength="11" placeholder="请输入手机号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务员" prop="userList" placeholder="请选择业务员">
              <el-select :filterable="true" :disabled="userList && userList.length === 1" v-model="form.userList" multiple placeholder="请选择">
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactName">
              <el-input v-model="form.contactName" placeholder="请输入联系人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址" prop="contactAddress">
              <el-input v-model="form.contactAddress" placeholder="请输入联系地址" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="银行名称" prop="bankName">
              <el-input v-model="form.bankName" placeholder="请输入银行名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号" prop="bankAccount">
              <el-input v-model="form.bankAccount" placeholder="请输入银行账号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编码" prop="userNo">
              <el-input v-model="form.userNo" placeholder="请输入客户编码" />
            </el-form-item>
          </el-col>
          <!-- 账套编码独立维护，采购下单时由后端校验是否已填写。 -->
          <el-col :span="12">
            <el-form-item label="账套编码" prop="accountSetCode">
              <el-input v-model.trim="form.accountSetCode" maxlength="100" placeholder="请输入账套编码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="form.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { deepClone } from '../../utils/utils'

export default {
  name: 'YgUserAdd',
  data() {
    return {
      userList: [],
      roles: [],
      form: {
        loginId: '', // 登录账号
        mobile: '', // 手机号
        roleId: '20240729155618804460', // 默认是客户角色
        password: '', // 密码
        deptId: '1',
        userName: '',
        bankName: '',
        bankAccount: '',
        userNo: '', // 客户/供应商的 T+ 往来单位编码
        accountSetCode: '', // 采购方的 T+ 账套编码
        userType: [],
        userList: [],
        fileList: [],
        contactName: '',
        contactAddress: ''
      },
      rules: {
        loginId: [{ required: true, message: '请输入登录账号', trigger: ['change', 'blur'] }],
        userType: [{ required: true, type: 'array', message: '请选择客户类型', trigger: ['change', 'blur'] }],
        userName: [{ required: true, message: '请输入名称', trigger: ['change', 'blur'] }],
        roleId: [{ required: true, message: '请选择角色', trigger: ['change', 'blur'] }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          {
            pattern: /^1[3-9]\d{9}$/, // 手机号正则校验
            message: '请输入有效的手机号',
            trigger: ['change', 'blur']
          }
        ],
        userList: [{ required: true, type: 'array', message: '请选择业务员' }]
      }
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId
    },
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.loadUserList()

    if (this.userId) {
      this.loadDetails()
    }
  },
  methods: {
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1',
        page: 1,
        size: 999
      }).then(res => {
        if (res.list && res.list.length > 1) {
          this.userList = res.list
        } else {
          this.userList = [
            { userId: this.user.userId, userName: this.user.userName }
          ]
          this.form.userList = [this.user.userId]
        }
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.system.selectSysUserByUserId, {
        params: { userId: this.userId }
      }).then(res => {
        res.userType = res.userType.split(',')
        this.form = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.system.insertSysUser
        if (this.userId) {
          url = this.$apis.system.updateSysUser
        }
        const formData = deepClone(this.form)
        formData.userType = formData.userType.sort().join()

        this.$axios.post(url, formData).then(() => {
          this.$router.back()
        })
      })
    },

    loadDepts() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.depts = res
      })
    },
    closeCascader() {
      this.$refs.cascader.dropDownVisible = false
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
